module.exports = __webpack_public_path__ + "img/20201214133851413g0l.bab05af7.png";